 <!-- Content Header (Page header) -->
 <section class="content-header">
  <div class="content-header">
     <div class="container-fluid">
       <div class="row mb-2">
         <div class="col-sm-6">
             <h3>Edit Role</h3>
         </div>
         <div class="col-sm-6">
           <ol class="breadcrumb float-sm-right">
             <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
             <li class="breadcrumb-item"><a routerLink="/settings/roles-list/ug"><i class="fa fa-list-ul"></i>&nbsp;View Roles</a></li>
             <li class="breadcrumb-item active">Edit Role</li>
           </ol>
         </div><!-- /.col -->
       </div><!-- /.row -->
     </div><!-- /.container-fluid -->
 </div>
 </section>
   <!-- /.content-header -->
 <section class="content">
 <div class="container-fluid">
 <div class="card">
     <div class="card-header">
       <h3 class="card-title">Edit Role</h3>
        <!--Error Message-->
        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
          <span [innerHTML]="errorMessage"></span>
        </div>
        <!--Success Message-->
        <div class="alert alert-success" role="alert" *ngIf="successMessage">
          {{successMessage}}
        </div>
     </div>
     <!-- /.card-header -->
     <div class="card-body">
         <form [formGroup]="form" (ngSubmit)="handleSubmit()">
             <div class="row clearfix">
                 <div class="col-md-4">
                     <div class="form-group">
                         <label>Role Name:<span style="color:red;">*</span></label>
                         <input type="text" formControlName="role_name" class="form-control" placeholder="Role Name" [(ngModel)]="roleData.role.name" [value]="roleData?.role?.name">
                         <span *ngIf="submitted && form.get('role_name')?.hasError('required')" style="color:red"> <strong>Please enter role name!</strong></span>
                     </div>
                 </div>
             </div>
         <div class="table-responsive">
            <table class="table">
              <tr>
                  <td><b><i>Permissions:</i></b></td>
              </tr>
              <tr>
                <td><b>Exports:</b></td>
                <td>
                    <input type="checkbox" formControlName="exp-view-bl-list" value="exp-view-bl-list">
                    View BL List
                </td>
                <td>
                  <input type="checkbox" formControlName="exp-view-bl-units" value="exp-view-bl-units">
                  View Units In BL
                </td>
                <td>
                  <input type="checkbox" formControlName="exp-view-stk-list" value="exp-view-stk-list">
                  View Stock List
                </td>
              </tr>
              <tr>
                <td><b>Customs & Clearing:</b></td>
                <td>
                    <input type="checkbox" formControlName="view-bl-list" value="view-bl-list">
                    View BL List
                </td>
                <td>
                    <input type="checkbox" formControlName="edit-bl" value="edit-bl">
                    Edit BL
                </td>
                <td>
                    <input type="checkbox" formControlName="update-bl" value="update-bl">
                    Update BL (Add Units)
                </td>
                <td>
                  <input type="checkbox" formControlName="delete-bl" value="delete-bl">
                  Delete BL
                </td>
                <td>
                    <input type="checkbox" formControlName="print-qr-codes" value="print-qr-codes">
                    Print QR Codes
                </td>
              </tr>
              <tr>
                  <td></td>
                  <td>
                      <input type="checkbox" formControlName="print-bl" value="print-bl">
                      Print BL
                  </td>
                  <td>
                    <input type="checkbox" formControlName="update-vsl-eta" value="update-vsl-eta">
                    Update Vessel ETA
                </td>
              </tr>
              <tr>
                <td><b>Stock Management:</b></td>
                <td>
                  <input type="checkbox" formControlName="view-ug-all-stk" value="view-ug-all-stk">
                  View All Stock
                </td>
                <td>
                  <input type="checkbox" formControlName="view-ug-all-avail-stk" value="view-ug-all-avail-stk">
                  View All Available Stock
                </td>
                <td>
                  <input type="checkbox" formControlName="view-ug-stk-enr" value="view-ug-stk-enr">
                  View Stock En route
                </td>
                <td>
                  <input type="checkbox" formControlName="view-ug-stk-at-cfs" value="view-ug-stk-at-cfs">
                  View Stock At CFS
                </td>
                <td>
                  <input type="checkbox" formControlName="view-ug-sld-cars" value="view-ug-sld-cars">
                    View Sold Cars
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <input type="checkbox" formControlName="view-vhcls-in-transit" value="view-vhcls-in-transit">
                  View Vehicles in Tansit
                </td>
                <td>
                  <input type="checkbox" formControlName="view-vhcl-transfer-hist" value="view-vhcl-transfer-hist">
                    View Vehicle Transfer History
                </td>
              </tr>
              <tr>
                <td><b>Vehicle Management:</b></td>
                <td>
                    <input type="checkbox" formControlName="view-vhcl-list" value="view-vhcl-list">
                    View Vehicle List
                </td>
                <td>
                    <input type="checkbox" formControlName="view-vhcl-details" value="view-vhcl-details">
                    View Vehicle Details
                </td>
                <td>
                    <input type="checkbox" formControlName="add-vhcl-photos" value="add-vhcl-photos">
                    Add Vehicle Photos
                </td>
                <td>
                    <input type="checkbox" formControlName="edit-vhcl" value="edit-vhcl">
                    Edit Vehicle
                </td>
                <td>
                    <input type="checkbox" formControlName="add-vhcl-atts" value="add-vhcl-atts">
                    Add Vehicle Attachments
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                    <input type="checkbox" formControlName="view-vhcl-atts" value="view-vhcl-atts">
                    View Vehicle Attachments
                </td>
                <td>
                    <input type="checkbox" formControlName="rplc-vhcl-atts" value="rplc-vhcl-atts">
                    Replace Vehicle Attachments
                </td>
                <td>
                  <input type="checkbox" formControlName="update-sp" value="update-sp">
                  Update Price
                </td>
                <td>
                    <input type="checkbox" formControlName="transfer-vhcl-sys" value="transfer-vhcl-sys">
                    Transfer Vehicle via System
                </td>
                <td>
                    <input type="checkbox" formControlName="del-vhcl-photos" value="del-vhcl-photos">
                    Delete Vehicle Photos
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                    <input type="checkbox" formControlName="view-port-photos-videos" value="view-port-photos-videos">
                    View Port Photos & Videos
                </td>
                <td>
                    <input type="checkbox" formControlName="add-vhcl-other-charges" value="add-vhcl-other-charges">
                    Add Other Charges
                </td>
                <td>
                    <input type="checkbox" formControlName="view-location" value="view-location">
                    View Vehicle Location Column
                </td>
                <td>
                    <input type="checkbox" formControlName="view-status" value="view-status">
                    View Vehicle Status Column
                </td>
              </tr>
              <tr>
                <td><b>System Administration:</b></td>
                <td>
                    <input type="checkbox" formControlName="mng-bnk-accts" value="mng-bnk-accts">
                    Manage Bank Accounts
                </td>
                <td>
                  <input type="checkbox" formControlName="mng-locations" value="mng-locations">
                  Manage Locations
                </td>
                <td>
                    <input type="checkbox" formControlName="mng-branches" value="mng-branches">
                    Manage Branches
                </td>
                <td>
                    <input type="checkbox" formControlName="mng-ug-users" value="mng-ug-users">
                    Manage Users
                </td>
                <td>
                    <input type="checkbox" formControlName="mng-ug-roles" value="mng-ug-roles">
                    Manage Roles
                </td>
              </tr>
              <tr>
                <td><b>Mobile App:</b></td>
                <td>
                    <input type="checkbox" formControlName="access-mobile-app" value="access-mobile-app">
                    Access the App
                </td>
                <td>
                    <input type="checkbox" formControlName="view-sp" value="view-sp">
                    View Selling Price
                </td>
                <td>
                    <input type="checkbox" formControlName="view-ug-duty" value="view-ug-duty">
                    View Duty
                </td>
                <td>
                    <input type="checkbox" formControlName="view-ot-chg" value="view-ot-chg">
                    View Other Charges
                </td>
                <td>
                  <input type="checkbox" formControlName="view-ttl-cst" value="view-ttl-cst">
                  View Total Cost
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                    <input type="checkbox" formControlName="mob-upd-spare-parts" value="mob-upd-spare-parts">
                    Update Spare Parts
                </td>
                <td>
                    <input type="checkbox" formControlName="mob-view-vhcl-atts" value="mob-view-vhcl-atts">
                    View Vehicle Documents
                </td>
                <td>
                    <input type="checkbox" formControlName="take-web-photos" value="take-web-photos">
                    Take Website Photos
                </td>
                <td>
                    <input type="checkbox" formControlName="add-web-vhcl-features" value="add-web-vhcl-features">
                    Add Vehicle Features
                </td>
                <td>
                    <input type="checkbox" formControlName="upload-web-photos" value="upload-web-photos">
                    Upload Web Photos
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                    <input type="checkbox" formControlName="transfer-vhcl" value="transfer-vhcl">
                    Transfer Vehicle
                </td>
                <td>
                    <input type="checkbox" formControlName="receive-vhcl" value="receive-vhcl">
                    Receive Vehicle
                </td>
                <td>
                    <input type="checkbox" formControlName="mob-view-stk-enr" value="mob-view-stk-enr">
                    View En route Stock
                </td>
                <td>
                    <input type="checkbox" formControlName="mob-view-stk-port-cfs" value="mob-view-stk-port-cfs">
                    View Port/CFS Stock
                </td>
                <td>
                  <input type="checkbox" formControlName="view-transit-vhcls" value="view-transit-vhcls">
                    View Transit Vehicles
                </td>
              </tr>
              <tr>
                <td><b>Notifications:</b></td>
                <td>
                    <input type="checkbox" formControlName="rcv-agent-acty-notif" value="rcv-agent-acty-notif">
                    Receive Agent Activity Notifications
                </td>
                <td>
                    <input type="checkbox" formControlName="rcv-stockout-notif" value="rcv-stockout-notif">
                    Receive Stockout Notifications
                </td>
              </tr>
            </table>
         </div>
         <div class="box-footer">
              <button class="btn btn-success" type="button" *ngIf="isProcessing; else showSaveBtn" disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Processing...
              </button>
              <ng-template #showSaveBtn>
                  <button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true">&nbsp;</i>Update</button>
              </ng-template>
         </div>
      </form>
     </div>
     <!-- /.card-body -->
 </div>
 </div>
 </section>
